import DOCUMENT_CONFIGS from './documentsVerificationConstants';

export default [
    {
        events: [DOCUMENT_CONFIGS.CHANGE_IN_ADDRESS_WITHIN_STATE, DOCUMENT_CONFIGS.MOVED_INTO_STATE],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_EXISTING_COVERAGE,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.EXHAUSTION_OF_COBRA_BENEFITS, DOCUMENT_CONFIGS.HEALTH_INSURANCE_PROOF],
            },
            {
                categoryType: DOCUMENT_CONFIGS.IDENTIFICATION,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.US_PASSPORT,
                    DOCUMENT_CONFIGS.PASSPORT_CARD,
                    DOCUMENT_CONFIGS.STAR_CARD,
                    DOCUMENT_CONFIGS.STATE_ISSUED_ID,
                    DOCUMENT_CONFIGS.DRIVER_LICENSE,
                    DOCUMENT_CONFIGS.VOTER_CARD,
                ],
            },
            {
                categoryType: DOCUMENT_CONFIGS.ADDRESS_PROOF,
                documentsQty: 2,
                documentTypes: [
                    DOCUMENT_CONFIGS.COLLEGE_ENROLLMENT_LETTER,
                    DOCUMENT_CONFIGS.AUTOMOBILE_REGISTRATION,
                    DOCUMENT_CONFIGS.RENTAL_AGREEMENT,
                    DOCUMENT_CONFIGS.HOME_PURCHASE_AGREEMENT,
                    DOCUMENT_CONFIGS.UTILITY_BILLS,
                    DOCUMENT_CONFIGS.HOME_PAYMENT_NOTICE,
                    DOCUMENT_CONFIGS.PROPERTY_TAX_NOTICE,
                    DOCUMENT_CONFIGS.OFFER_OF_EMPLOYMENT,
                ],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.MARRIAGE, DOCUMENT_CONFIGS.DIVORCE],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_MARRIAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.MARRIAGE_CERTIFICATE,
                    DOCUMENT_CONFIGS.COURT_ORDER_PETITION_NAME_CHANGE,
                    DOCUMENT_CONFIGS.DOMESTIC_LEGAL_DOCUMENT,
                    DOCUMENT_CONFIGS.VALIDATION_ON_ID_REPOSITORY,
                ],
            },
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_EXISTING_COVERAGE,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.EXHAUSTION_OF_COBRA_BENEFITS, DOCUMENT_CONFIGS.HEALTH_INSURANCE_PROOF],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.DEATH_OF_PTF_OR_SUBSCRIBER, DOCUMENT_CONFIGS.DEATH],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.DOC_INDICATING_PROOF_OF_DEATH,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.DEATH_CERTIFICATE,
                    DOCUMENT_CONFIGS.SIGNED_AFFIDAVIT,
                    DOCUMENT_CONFIGS.OBITUARY,
                ],
            },
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_AI_AN_STATUS,
            DOCUMENT_CONFIGS.CHANGE_IN_TRIBE_STATUS,
            DOCUMENT_CONFIGS.GAIN_IN_TRIBE_STATUS,
            DOCUMENT_CONFIGS.GAIN_OF_AMERICAN_INDIAN_STATUS,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_AIAN,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.CERT_INDIAN_ALASKAN_BLOOD_FROM_BIA,
                    DOCUMENT_CONFIGS.TRIBAL_MEMBERSHIP,
                ],
            },
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_HOUSEHOLD_SIZE,
            DOCUMENT_CONFIGS.BIRTH,
            DOCUMENT_CONFIGS.BIRTH_ADOPTION,
            DOCUMENT_CONFIGS.ADD_DEPENDENT,
            DOCUMENT_CONFIGS.ADD_DEPENDENTS,
            DOCUMENT_CONFIGS.ADOPTION,
            DOCUMENT_CONFIGS.GAIN_COURT_APPOINTED_DEPENDENT,
            DOCUMENT_CONFIGS.REMOVE_DEPENDENT,
            DOCUMENT_CONFIGS.BIRTH_OR_ADOPTION,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.DOC_INDICATING_ADD_REMOVE_OF_DEP,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.BIRTH_CERTIFICATE, DOCUMENT_CONFIGS.COURT_ORDER_INDICATING_ADD_REMOVE],
            },
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.LOSS_OF_MEC,
            DOCUMENT_CONFIGS.LOSE_COVERAGE_NON_PAYMENT,
            DOCUMENT_CONFIGS.LOSE_COVERAGE_NON_PAYMENT_TYPE4,
            DOCUMENT_CONFIGS.LOSE_EMPLOYER_COVERAGE,
            DOCUMENT_CONFIGS.LOSE_EMPLOYER_COVERAGE_TYPE4,
            DOCUMENT_CONFIGS.LOSE_OTHER_PUBLIC_MEC,
            DOCUMENT_CONFIGS.LOSE_OTHER_PUBLIC_MEC_TYPE4,
            DOCUMENT_CONFIGS.LOSS_OF_COVERAGE_THROUGH_EMPLOYER,
            DOCUMENT_CONFIGS.LOSS_OF_COVERAGE_THROUGH_EMPLOYER_FUTURE,
            DOCUMENT_CONFIGS.LOSS_OF_MEC_FUTURE,
            DOCUMENT_CONFIGS.LOST_OTHER_MIN_ESSENTIAL_COVERAGE,
            DOCUMENT_CONFIGS.LOST_OTHER_MIN_ESSENTIAL_COVERAGE_FUTURE,
            DOCUMENT_CONFIGS.PRIMARY_GAIN_OF_MEC,
            DOCUMENT_CONFIGS.PRIMARY_GAIN_OF_MEC_FUTURE,
            DOCUMENT_CONFIGS.CHILD_AGED_OUT_FROM_OLD_APPLICATION,
            DOCUMENT_CONFIGS.EXEMPTION_CANCELLED,
            DOCUMENT_CONFIGS.LOSS_OF_MEDICAID,
            DOCUMENT_CONFIGS.LOSS_OF_MEDICAID_FUTURE,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_LOSS_OF_COVERAGE,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.TERM_LETTER_FROM_CARRIER,
                    DOCUMENT_CONFIGS.TERM_LETTER_FROM_GOV_PROVIDER,
                    DOCUMENT_CONFIGS.EMPLYR_CONTRI_TERM_FRM_COBRA,
                    DOCUMENT_CONFIGS.EMPLYR_CONTRI_TERM_FRM_EMPLYR,
                    DOCUMENT_CONFIGS.FUND_EXHAUSTION_FM_PERSI,
                    DOCUMENT_CONFIGS.PRIOR_EMPLYR_LOSS_OF_COVERAGE,
                ],
            },
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_INCARCERATION,
            DOCUMENT_CONFIGS.INCARCERATION,
            DOCUMENT_CONFIGS.NOT_INCARCERATED,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_INCARCERATION_STATUS,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.VERIFICATION_OF_TIME_SERVED],
            },
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_CONFIRM_CONVICTION_DISPOSITION,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.CONFIRM_CONVICTION_DISP_CHARGES],
            },
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.NEWLY_ELIG_FOR_APTC,
            DOCUMENT_CONFIGS.INCOME_CHANGE_CSR,
            DOCUMENT_CONFIGS.CHANGE_IN_INCOME,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_INCOME_CHANGE,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.PROOF_OF_INCOME],
            },
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_EXISTING_COVERAGE,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.EXHAUSTION_OF_COBRA_BENEFITS, DOCUMENT_CONFIGS.HEALTH_INSURANCE_PROOF],
            },
            {
                categoryType: DOCUMENT_CONFIGS.EXCHANGE_CONFIRMATION_OF_APTC,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.APTC_ELIG_CONFIRM_LETTER],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.OTHER_EXCEPTIONAL_CIRCUMSTANCES],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.DOC_INDICATING_EXCEPTIONS,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.REPORT_TO_MILITARY_DUTY,
                    DOCUMENT_CONFIGS.MEDICAL_CONDITIONS,
                    DOCUMENT_CONFIGS.TECHNICAL_ISSUE,
                    DOCUMENT_CONFIGS.OTHER_EXCEPTIONS,
                ],
            },
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.CHANGE_IN_LEGAL_PRESENCE,
            DOCUMENT_CONFIGS.CHANGE_IN_CITIZENSHIP,
            DOCUMENT_CONFIGS.GAIN_CITIZENSHIP,
            DOCUMENT_CONFIGS.GAIN_LPR,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_LEGAL_STATUS,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.US_PASSPORT,
                    DOCUMENT_CONFIGS.PASSPORT_CARD,
                    DOCUMENT_CONFIGS.CERT_OF_NATURALIZATION,
                    DOCUMENT_CONFIGS.CERT_OF_US_CITIZENSHIP,
                    DOCUMENT_CONFIGS.TRIBAL_DOCUMENT,
                    DOCUMENT_CONFIGS.US_BIRTH_CERTIFICATE,
                    DOCUMENT_CONFIGS.RESIDENT_ALIEN_CARD,
                    DOCUMENT_CONFIGS.DOC_INDICATING_LEGAL_STATUS,
                ],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.CHANGE_IN_ADDRESS],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_EXISTING_COVERAGE,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.EXHAUSTION_OF_COBRA_BENEFITS, DOCUMENT_CONFIGS.HEALTH_INSURANCE_PROOF],
            },
            {
                categoryType: DOCUMENT_CONFIGS.IDENTIFICATION,
                documentsQty: 1,
                documentTypes: [
                    DOCUMENT_CONFIGS.US_PASSPORT,
                    DOCUMENT_CONFIGS.PASSPORT_CARD,
                    DOCUMENT_CONFIGS.STAR_CARD,
                    DOCUMENT_CONFIGS.STATE_ISSUED_ID,
                    DOCUMENT_CONFIGS.DRIVER_LICENSE,
                    DOCUMENT_CONFIGS.VOTER_CARD,
                ],
            },
            {
                categoryType: DOCUMENT_CONFIGS.CURRENT_ADDRESS_PROOF,
                documentsQty: 2,
                documentTypes: [
                    DOCUMENT_CONFIGS.COLLEGE_ENROLLMENT_LETTER,
                    DOCUMENT_CONFIGS.AUTOMOBILE_REGISTRATION,
                    DOCUMENT_CONFIGS.RENTAL_AGREEMENT,
                    DOCUMENT_CONFIGS.HOME_PURCHASE_AGREEMENT,
                    DOCUMENT_CONFIGS.UTILITY_BILLS,
                    DOCUMENT_CONFIGS.HOME_PAYMENT_NOTICE,
                    DOCUMENT_CONFIGS.PROPERTY_TAX_NOTICE,
                    DOCUMENT_CONFIGS.OFFER_OF_EMPLOYMENT,
                ],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.EMPLOYER_SPONSORED_COVERAGE_UNAFFORDABLE],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_UNAAFFORDABLE_ESI,
                documentsQty: 2,
                documentTypes: [
                    DOCUMENT_CONFIGS.EMPLYR_COVERAGE_OFFER,
                    DOCUMENT_CONFIGS.PROOF_OF_EXISTING_ESC,
                ],
            },
        ],
    },
    {
        events: [
            DOCUMENT_CONFIGS.ICHRA_SEP,
            DOCUMENT_CONFIGS.ICHRA_SEP_FUTURE,
            DOCUMENT_CONFIGS.QSEHRA_SEP,
            DOCUMENT_CONFIGS.QSEHRA_SEP_FUTURE,
        ],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.PROOF_OF_HRA_OFFER,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.HRA_OFFER_DOCUMENT],
            },
        ],
    },
    {
        events: [DOCUMENT_CONFIGS.UNSUPPORTED_EVENT],
        documents: [
            {
                categoryType: DOCUMENT_CONFIGS.DOC_PROVING_EVENT,
                documentsQty: 1,
                documentTypes: [DOCUMENT_CONFIGS.DOC_SUPPORTING_EVENT],
            },
        ],
    },
];
